import { IHttpClient } from "../../../lib/http";
import { CreatePropertyRequestDto } from "../domain/createProperty.entity";

export async function executeCloned(
  httpClient: IHttpClient,
  originPropertyTicker: string,
  targetPropertyTicker: string,
  options: {
    migrateAri: boolean;
    migrateInventory: boolean;
  },
  emails?: string[]
): Promise<void> {
  await httpClient.post<CreatePropertyRequestDto, void>(
    "/replicate",
    {
      toDevel: false,
      originPropertyTicker,
      targetPropertyTicker,
      emails,
      options,
    },
    {
      params: {
        executionName: `clone-${originPropertyTicker}-${targetPropertyTicker}-${new Date().getTime()}`,
      },
    }
  );
}
